// Lazy load function
const lazyLoad = (file) => () =>
    import(/* webpackChunkName: "[request]" */ `@/views/customers/${file}.vue`);

export default [
    // Customer Pallet Accounts
    {
        path: "/customer-pallet-account/:id",
        name: "customer-pallet-account",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CustomerPalletAccount",
        },
        components: {
            content: lazyLoad('customer-pallet-account'),
        },
    },
    {
        path: "/customer-pallet-account/create/:id",
        name: "customer-pallet-account-create",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CustomerPalletAccount",
        },
        components: {
            content: lazyLoad('customer-pallet-account'),
        },
    },
    {
        path: "/customer-pallet-account/review/:id",
        name: "customer-pallet-account-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CustomerPalletAccount",
        },
        components: {
            content: lazyLoad('customer-pallet-account'),
        },
    },
    {
        path: "/customer-pallet-account/edit/:id",
        name: "customer-pallet-account-edit",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "CustomerPalletAccount",
        },
        components: {
            content: lazyLoad('customer-pallet-account'),
        },
    },
];
